import React from "react";
import { useSelector } from "react-redux";
import ItemProduct from "../../Common/ItemProduct";
import Order from "../../Common/Order";
import Payment from "../../Common/Payment";
import UserBuyer from "../../Common/UserBuyer";
import ContractTimes from "../../Common/ContractTimes";
import OtherPayments from "../../Common/OtherPayments";

const Index = ({ data, role,updateAll, setUpdateAll,isAbsent,appModal }) => {
  const { user } = useSelector(state => state);
  if (role) {
    return (
      <div>
        <ItemProduct details={{ item_name: data.product.item_name }} />
        <Order order={data.order} />
        <Payment payment={data.peyment} title={"مشخصات آخرین پرداخت"} />
        <OtherPayments other={data.other_payment} />

        <ContractTimes appModal={appModal} isAbsent={isAbsent} times={data.times} />
      </div>
    );
  }
  return (
    <div>
      {user.role != "manager" ? (
        <ItemProduct details={{ item_name: data.product.item_name }} />
      ) : (
        <></>
      )}
      <Order order={data.order} />
      <Payment payment={data.peyment} title={"مشخصات آخرین پرداخت"} />
      <OtherPayments other={data.other_payment} />
      {user.role != "user" ? <UserBuyer userbuyer={data.user_buyer} /> : <></>}
      <ContractTimes appModal={appModal} isAbsent={isAbsent} times={data.times} role={user.role} order={data.order} updateAll={updateAll} setUpdateAll={setUpdateAll}/>
    </div>
  );
};

export default Index;
